import { Component, OnInit, EventEmitter,Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-confirmacion-anulacion-modal',
  templateUrl: './confirmacion-anulacion-modal.component.html',
  styleUrls: ['./confirmacion-anulacion-modal.component.css']
})
export class ConfirmacionAnulacionModalComponent implements OnInit {
  @Input() Pregunta: string;
  @Output() Respuesta: boolean;
  @Output() action = new EventEmitter();
	public loading: boolean;

	constructor(
		public bsModalRef: BsModalRef,
	) {
		this.loading = false;
	}

	ngOnInit() {
		
	}

	Response(){
		this.Respuesta = true;
		this.action.emit(true);
		this.bsModalRef.hide();
	}

	Cancel(){
		this.Respuesta = false;
		this.action.emit(false);
		this.bsModalRef.hide();
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component.ts